// extracted by mini-css-extract-plugin
export default {"order_wrapper":"PaymentOrder_order_wrapper__m2pTM","list":"PaymentOrder_list__e5t0o","bold":"PaymentOrder_bold__AocdW","big":"PaymentOrder_big__N7d0m"};